import { render, staticRenderFns } from "./YA_RewriteContent1.vue?vue&type=template&id=0b762b1a&scoped=true"
import script from "./YA_RewriteContent1.vue?vue&type=script&lang=js"
export * from "./YA_RewriteContent1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b762b1a",
  null
  
)

export default component.exports